
<template>
    <div class="advertisement">
      <img :src="require('@/assets/images/970645_2912.jpg')" alt="Reklama">
    </div>
  </template>
  
  <style scoped>
.advertisement, .promoted-ads {
  /* background: #f4f4f4; Jasnoszare tło */
  /* padding: 20px; Padding dla estetyki */
  margin-top: 20px; /* Odstęp od górnego elementu */
  border-radius: 8px; /* Zaokrąglone rogi */
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); Lekki cień dla wyróżnienia */
}

.advertisement img, .promoted-ads img {
  max-width: 100%; /* Zapewnienie, że obrazy nie wyjdą poza kontener */
  height: auto; /* Zachowanie proporcji obrazów */
  border-radius: 4px; /* Zaokrąglone rogi dla obrazów */
}

  </style>
  